import get from 'lodash/get'

export const isReplayEnabled = (channelData) => {

  const features = get(channelData, 'features')
  if (!features) {

    return false

  }

  return !!channelData.features.find(({ name, enabled }) => name === 'replay' && enabled === true)

}
